interface CautionRailProps {
  placement?: 'top' | 'bottom'
}

export function CautionRail({ placement = 'top' }: CautionRailProps) {
  return (
    <div
      aria-hidden="true"
      className={`caution-rail caution-rail--${placement}`}
      data-caution-rail={placement}
    >
      <div className="caution-rail__track">
        {Array.from({ length: 12 }, (_, index) => (
          <span className="caution-rail__label" key={index}>Caution</span>
        ))}
      </div>
    </div>
  )
}
